import createStore from "astrid-helpers/src/createStore";
import { setSelection } from "./selection";
export const [getInternalPage, setInternalPage, usePage, onPage] = createStore([1, false]);
export function getPage() {
  return getInternalPage()[0];
}
export function setPage(page, autoScroll = true) {
  if (page) {
    setSelection();
    return setInternalPage([page, autoScroll]);
  }
}
//# sourceMappingURL=page.js.map